import pageLoading from './lib/pageLoading.js';
import modalImage from './lib/modalImage.js';
// import { isPage, isMobile } from "./lib/util";
// import scrollEffect from "./lib/scrollEffect.js";
// import observer from "./lib/observer.js";
import gsap from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import topValidation from 'top-validation';
import '@/scss/design.scss';

document.addEventListener('DOMContentLoaded', () => {
  modalImage();
});


/* ----------------------------------
  　お問い合わせ関連
---------------------------------- */
// // //お問い合わせバリデーション
if(document.body.classList.contains("contact")){
  topValidation('zip', 'address01', 'address02');
}


gsap.registerPlugin(ScrollToPlugin);

// お問い合わせスクロール
document.addEventListener('tccf7:scrollTo', e => {
  const header = document.querySelector('.header');
  const headerHeight = header ? header.offsetHeight : 0;
  const extraOffset = 100;

  gsap.to(window, {
    duration: 1,
    scrollTo: {
      y: "#" + e.detail.id,
      offsetY: headerHeight
    },
    ease: "power2.inOut"
  });
});

/* ----------------------------------
　ヘッダーのスクロール挙動
---------------------------------- */
document.addEventListener('DOMContentLoaded', function() {
    
    const header = document.querySelector('.header');
    const mainImg = document.querySelector('.mainimg');
    const footer = document.querySelector('footer');

    if (!header || !mainImg || !footer) return;

    window.addEventListener('scroll', function() {
    if (window.innerWidth <= 970) {
            header.classList.remove('is-fixed');
            header.classList.remove('is-hide');
            return; 
          }
      const scrollY = window.scrollY;
      const triggerHeight = mainImg.offsetHeight;
      const headerHeight = header.offsetHeight;
      const footerTop = footer.getBoundingClientRect().top;

      if (scrollY <= triggerHeight) {
        header.classList.remove('is-fixed');
        header.classList.remove('is-hide');
      } 

      else {
        header.classList.add('is-fixed');

        if (footerTop <= headerHeight) {
           header.classList.add('is-hide');
        } else {
           header.classList.remove('is-hide');
        }
      }
    });
  });

/* ----------------------------------
　humberger menu
---------------------------------- */
window.addEventListener('load', () => {
  const navEle = document.querySelector('.hd_menu-toggle');
  const navWrap = document.querySelector('.hd_nav');
  const navItems = document.querySelectorAll('.hd_nav_li');

  navEle.addEventListener('click', () => {
    const isOpen = navWrap.classList.contains('is_open');

    if (!isOpen) {
      // 開くとき
      navWrap.classList.add('is_open');

      navItems.forEach((item, i) => {
        setTimeout(() => {
          item.classList.add('show');
          item.classList.remove('hide');
        }, i * 120);
      });

    } else {
      // 閉じるとき
      navItems.forEach((item, i) => {
        setTimeout(() => {
          item.classList.remove('show');
        }, i * 80);
      });

      // パネル自体も同時に左へスライド
      navWrap.classList.add('hide-panel');
      setTimeout(() => {
        navWrap.classList.remove('is_open', 'hide-panel');
      }, 500); // CSSトランジション時間に合わせる
    }

    navEle.classList.toggle('is_open', !isOpen);
  });
});


/* ----------------------------------
　車両詳細ページのサムネイル切り替え
---------------------------------- */
document.addEventListener('DOMContentLoaded', function() {
  const thumbnails = document.querySelectorAll('.thumbnail-link');
  const mainImage = document.querySelector('#mainVehicleImage');
  const mainImageLink = document.querySelector('#mainVehicleLink');
  const hiddenLinks = document.querySelectorAll('.vehicle_gallery_hidden .boxer');
  
  // サムネイルがある場合のみ、サムネイルクリック処理を設定
  if (thumbnails.length > 0 && mainImage && mainImageLink) {
    // サムネイルクリック時の処理
    thumbnails.forEach(thumbnail => {
      thumbnail.addEventListener('click', function(e) {
        e.preventDefault();
        
        const imageUrl = this.getAttribute('data-image-url');
        const imageIndex = parseInt(this.getAttribute('data-index'));
        
        // フェードアウト
        mainImage.style.opacity = '0';
        
        // 画像切り替え（フェードアウト完了後）
        setTimeout(() => {
          mainImage.src = imageUrl;
          
          // 現在のインデックスを保存
          mainImageLink.setAttribute('data-current-index', imageIndex);
          
          // フェードイン
          mainImage.style.opacity = '1';
        }, 300);
        
        // activeクラスの切り替え
        document.querySelectorAll('.vehicle_thumb').forEach(thumb => {
          thumb.classList.remove('active');
        });
        this.parentElement.classList.add('active');
      });
    });
  }
  
  // メイン画像クリック時の処理（画像が1枚でも動作）
  if (mainImageLink && hiddenLinks.length > 0) {
    mainImageLink.addEventListener('click', function(e) {
      e.preventDefault();
      
      const currentIndex = parseInt(this.getAttribute('data-current-index')) || 0;
      
      // 現在表示中の画像に対応する隠しリンクをクリック
      if (hiddenLinks[currentIndex]) {
        hiddenLinks[currentIndex].click();
      }
    });
  }
});





/* ----------------------------------
  　トップページ機材紹介スライダー
---------------------------------- */
document.addEventListener('DOMContentLoaded', function() {
  const swiper = new Swiper('.mySwiper', {
    // ■ 基本設定（スマホ用 0px〜768px）
    loop: true,
    speed: 1000,
    spaceBetween: 20,
    centeredSlides: false,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    slidesPerView: 1, 
    // ■ レスポンシブ設定
    breakpoints: {
      769: {
        slidesPerView: 'auto', 
        centeredSlides: false,
        spaceBetween: 30,
      },
      1025: {
        slidesPerView: 'auto',
        centeredSlides: false,
        spaceBetween: 54,
      }
    },

    navigation: {
      nextEl: '.top_equipment_slider_btn_next',
      prevEl: '.top_equipment_slider_btn_prev',
    },
  });
});

/* ----------------------------------
  　トップページ修理事例スライダー
---------------------------------- */
document.addEventListener('DOMContentLoaded', function() {
  const repairSlider = new Swiper('.top_repair_swiper', {
    // ■ 基本設定（スマホ用 0px〜768px）
    loop: false,
    speed: 1000,
    spaceBetween: 20,
    centeredSlides: false,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    slidesPerView: 1,
    initialSlide: 0,
    // ■ レスポンシブ設定
    breakpoints: {
      769: {
        slidesPerView: 3,
        centeredSlides: false,
        spaceBetween: 30,
      },
      1025: {
        slidesPerView: 3,
        centeredSlides: false,
        spaceBetween: 50,
      }
    },

    navigation: {
      nextEl: '.top_repair_slider_btn_next',
      prevEl: '.top_repair_slider_btn_prev',
      disabledClass: 'swiper-button-disabled',
    },
  });
});